// Chrome island: nav — hamburger toggle for narrow widths.
(function () {
  "use strict";

  document.querySelectorAll(".hd-nav").forEach(function (nav) {
    var burger = nav.querySelector(".hd-nav__burger");
    if (!burger) return;

    burger.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });

    nav.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && nav.classList.contains("is-open")) {
        nav.classList.remove("is-open");
        burger.setAttribute("aria-expanded", "false");
        burger.focus();
      }
    });
  });
})();
